<template>
  <div v-if="showModal" class="session-warning-modal">
    <div class="modal-backdrop" @click="handleBackdropClick"></div>
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="bi bi-clock text-warning me-2"></i>
          Sesión Expirando
        </h5>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <div class="mb-3">
            <i class="bi bi-exclamation-triangle text-warning" style="font-size: 3rem;"></i>
          </div>
          <p class="mb-3">
            Tu sesión está a punto de expirar. ¿Deseas mantenerte conectado?
          </p>
          <div class="countdown-timer">
            <small class="text-muted">
              Tiempo restante: <strong>{{ countdown }}</strong> segundos
            </small>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          @click="cerrarSesion"
          :disabled="loading"
        >
          <i class="bi bi-box-arrow-right me-1"></i>
          Cerrar Sesión
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="extendSession"
          :disabled="loading"
        >
          <i class="bi bi-check-circle me-1"></i>
          Mantener Conectado
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import authService from '@/services/servicioAutenticacion'
import router from '@/router'

export default {
  name: 'SessionWarningModal',
  data() {
    return {
      showModal: false,
      countdown: 60, // 1 minuto
      countdownInterval: null,
      loading: false
    }
  },
  methods: {
    show() {
      this.showModal = true
      this.countdown = 60
      this.startCountdown()
    },

    hide() {
      this.showModal = false
      this.stopCountdown()
    },

    startCountdown() {
      this.stopCountdown() // Asegurarse de que no haya intervalos previos
      this.countdownInterval = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          this.cerrarSesion()
        }
      }, 1000)
    },

    stopCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval)
        this.countdownInterval = null
      }
    },

    async extendSession() {
      try {
        this.loading = true
        await authService.refrescarSesion()
        this.hide()
        this.$emit('session-extended')
      } catch (error) {
        console.error('Error extending session:', error)
        this.cerrarSesion()
      } finally {
        this.loading = false
      }
    },

    cerrarSesion() {
      this.hide()
      authService.cerrarSesion()
      router.push('/iniciar-sesion')
    },

    handleBackdropClick() {
      // No permitir cerrar haciendo clic fuera del modal
    }
  },

  beforeUnmount() {
    this.stopCountdown()
  }
}
</script>

<style scoped>
.session-warning-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  z-index: 99998;
}

.modal-content {
  position: relative;
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  max-width: 420px;
  width: 90%;
  margin: 20px;
  animation: modalSlideIn 0.3s ease-out;
  z-index: 99999;
}

.dark-theme .modal-content {
  background: #2d3748;
  color: #e2e8f0;
  border: 1px solid #4a5568;
}

.modal-header {
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #dee2e6;
  border-radius: 12px 12px 0 0;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
}

.dark-theme .modal-header {
  border-bottom-color: #4a5568;
}

.modal-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.modal-body {
  padding: 1.5rem;
}

.countdown-timer {
  margin-top: 1rem;
  padding: 0.75rem;
  background: #fef3c7;
  border-radius: 8px;
  border: 1px solid #fcd34d;
  font-size: 1rem;
}

.dark-theme .countdown-timer {
  background: #1a202c;
  border-color: #4a5568;
  color: #e2e8f0;
}

.countdown-timer strong {
  font-size: 1.25rem;
  color: #d97706;
}

.dark-theme .countdown-timer strong {
  color: #fbbf24;
}

.modal-footer {
  padding: 1rem 1.5rem 1.25rem;
  border-top: 1px solid #dee2e6;
  border-radius: 0 0 12px 12px;
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  background: #f9fafb;
}

.dark-theme .modal-footer {
  border-top-color: #4a5568;
  background: #1f2937;
}

.modal-footer .btn {
  flex: 1;
  border-radius: 8px;
  font-weight: 500;
  padding: 0.625rem 1rem;
  transition: all 0.2s ease;
  font-size: 0.95rem;
}

.modal-footer .btn-primary {
  background: #0d6efd;
  border-color: #0d6efd;
}

.modal-footer .btn-primary:hover:not(:disabled) {
  background: #0b5ed7;
  border-color: #0a58ca;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(13, 110, 253, 0.4);
}

.modal-footer .btn-outline-secondary:hover:not(:disabled) {
  transform: translateY(-1px);
}

.modal-footer .btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@media (max-width: 576px) {
  .modal-content {
    margin: 15px;
    width: calc(100% - 30px);
  }

  .modal-header,
  .modal-body {
    padding: 1rem 1.25rem;
  }

  .modal-footer {
    padding: 1rem 1.25rem;
    flex-direction: column;
  }

  .modal-footer .btn {
    width: 100%;
  }
}
</style>



